// Franse teksten van de to-do's in de ouderapp (zie todoApp.nl.ts).
export const appTodoFr = {
    tab: 'À faire',
    repeatOption: 'Sans date (à faire)',
    repeatHint: 'Ni date ni heure. La tâche reste jusqu’à ce qu’elle soit faite.',
    description: 'Détails (facultatif)',
    dueDate: 'Au plus tard (facultatif)',
    dueClear: 'Pas de date limite',
    from: 'de {name}',
    due: 'au plus tard le {date}',
    emptyTitle: 'Rien à faire',
    emptyBody: 'Une chose à faire n’a ni date ni heure et reste jusqu’à ce qu’elle soit faite. Par exemple : peindre le meuble à chaussures.',
    add: 'Ajouter une chose à faire',
    doneSection: 'Fait',
    doneOn: 'fait le {date}',
    newTitle: 'Nouvelle chose à faire',
    editTitle: 'Modifier la chose à faire',
    important: 'Important',
    importantHint: 'Affiché en haut, avec une petite marque.',
    assign: 'Attribuer à',
    assignHint: 'Les bébés et les tout-petits ne reçoivent pas de choses à faire.',
    assigned: 'Attribué à {names}',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: 'Toi seul vois ces tâches. Ni la famille, ni le tableau. Quelque chose n’apparaît sur le tableau que si tu le confirmes toi-même expressément pour une tablette ; tu peux toujours le retirer.',
    privateEntry: 'Une tâche privée ? Crée-la dans Mon espace. Là, toi seul la vois.',
    privateEntryButton: 'Aller à Mon espace',
    gateTitle: 'Tes propres tâches à faire',
    gateBody: 'Tes propres tâches à faire sont dans Mon espace. Toi seul les vois : ni la famille, ni le tableau. Quelque chose n’apparaît sur le tableau que si tu le confirmes toi-même expressément pour une tablette ; tu peux toujours le retirer.',
    gateOpen: 'Ouvrir Mon espace',
    gateOpening: 'Ouverture…',
    widgetEmpty: 'Aucune tâche à faire ouverte.',
    widgetAll: 'Toutes les tâches à faire',
    widgetMore: '+{count} de plus',
    widgetFrom: 'De {name}, lecture seule',
    widgetOpenIn: 'Ouvrir dans {name}',
    widgetPending: 'En attente d’approbation',
};
//# sourceMappingURL=todoApp.fr.js.map